<!--
 * @Description: 弹窗模块
 * @Autor: lwq
 * @Date: 2020-08-15 14:42:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-19 17:57:33
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\viewDataOfSubordinates\dialogModule.vue
-->
<template>
  <mrc_ess_myDialog :isopen="isopen"
                    @cancel="cancel"
                    @success="success"
                    @flag="flag"
                    width="50vw"
                    :title="title"
                    :disabled="true">
    <v-row>
      <!-- <mrc_ess_switch :true-value="1"
                      v-if="$store.state.uuid"
                      :false-value="0"
                      :readonly="readonly"
                      v-model="params.status"
                      :label="params.status == 1 ? $t('label_To_enable_the') : $t('label_disable')">
      </mrc_ess_switch> -->
      <v-col cols="12">
        <!-- <mrc_ess_prompt :label="$t('label_Position_Title')+'*'"
                        :rules='false'
                        :disabled="readonly"
                        :errMsg="$errors('params', 'post_uuid', requiredRule)"
                        multiple
                        positionView
                        v-model="params.post_uuid"
                        :obj="job_post_uuid">
        </mrc_ess_prompt> -->
        <mrc_ess_autoComplete :label="$t('label_Position_Title') + '*'"
                              :readonly="readonly"
                              multiple
                              positionView
                              :error-messages="$errors('params', 'post_uuid', requiredRule)"
                              v-model="params.post_uuid"
                              :prompt_name="company_post">
        </mrc_ess_autoComplete>
      </v-col>
      <v-col cols="12">
        <mrc_ess_autoComplete :label="$t('label_Viewed_organization') + '*'"
                              :readonly="readonly"
                              multiple
                              deptView
                              :errorMessages="$errors('params', 'org_level_uuids', requiredRule)"
                              v-model="params.org_level_uuids"
                              :prompt_name="dept_uuid"></mrc_ess_autoComplete>
      </v-col>
      <v-col cols="12">
        <mrc_ess_staffInfo v-model="params.exclude_staff_uuids"
                           :readonly="readonly"
                           defaultRequest
                           item-value="staff_id"
                           :label="$t('label_Exclude_people')"
                           :multiple="true"
                           filter="1,2,3,5">
        </mrc_ess_staffInfo>
      </v-col>
      <v-col cols="12">
        <!--  :error-messages="$errors('params', 'exclude_function_uuids', requiredRule)" -->
        <tree v-model="params.exclude_function_uuids"></tree>
        <!-- <div :error-messages="$errors('params', 'exclude_function_uuids', requiredRule)"
             style="font-size:12px;color:rgb(255, 82, 82);position:relative;top:-15px;">
          {{ $errors('params', 'exclude_function_uuids', requiredRule)[0] }}
        </div> -->
      </v-col>

      <!-- :errorMessages="$errors('params', 'exclude_staff_uuids', requiredRule)" -->

      <!-- label_Employee_name -->
      <!-- $t('label_cancel') -->
    </v-row>
  </mrc_ess_myDialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import tree from '../tree.vue'
export default {
  components: { tree },
  props: {
    title: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isopen: {
      type: Boolean,
      default: false,
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  model: {
    prop: 'isopen',
    event: 'flag',
  },
  data () {
    return {
      params: {
        status: 1,
        post_uuid: '',
        org_level_uuids: '',
        exclude_staff_uuids: '',
      },
      type: 0, // 0新增 1修改
    }
  },
  validations: {
    params: {
      post_uuid: {
        required,
      },
      org_level_uuids: {
        required,
      },
      exclude_staff_uuids: {
        // required,
      },
      exclude_function_uuids: {
        // required,
      },
    },
  },
  computed: {
    job_post_uuid () {
      //岗位查询
      return {
        prompt_name: 'job_post',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    company_post () {
      return {
        prompt_name: 'company_post',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
    dept_uuid () {
      return {
        prompt_name: 'levelUuid_deptUuid',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
  },
  created () { },
  watch: {
    paramsData (v) {
      if (Object.keys(v).length > 0) this.type = 1
      else this.type = 0
      this.params = this.$clone(v)
      // if (v.status) {
      //   this.params = this.$clone(v)
      // } else {
      //   this.params = { ...this.$clone(v), status: 1 }
      // }
    },
  },
  mounted () {
    this.params = this.$clone(this.paramsData)
    if (Object.keys(this.params).length > 0) this.type = 1
    else this.type = 0
    // if (this.$clone(this.paramsData).status) {
    //   this.params = this.$clone(this.paramsData)
    // } else {
    //   this.params = { ...this.$clone(this.paramsData), status: 1 }
    // }
  },

  methods: {
    cancel () {
      this.$emit('flag', !this.isopen)
      this.$emit('cancel')
    },
    success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit('getData', this.params, this.type)
      this.$emit('flag', !this.isopen)
    },
    flag () {
      this.$v.params.$reset()
    },
  },
}
</script>

<style scoped></style>
